import { cva } from '@/styled-system/css';

export const tabsListRecipe = cva({
  base: {
    display: 'flex',
    alignItems: 'stretch',
    marginBottom: 'Tabs.offsetBorder',
    position: 'relative',
    zIndex: 1,
  },
  variants: {
    appearance: {
      default: {
        borderBottomWidth: 'Tabs.default',
        borderBottomStyle: 'solid',
        borderBottomColor: 'Tabs.default.border.track',
      },
      file: {},
    },
    fluid: {
      true: {},
      false: {},
    },
  },
});
